// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mun-squareselector{outline:none}", "",{"version":3,"sources":["webpack://./../design-system/build/components/molecules/Charts/components/pieChart/pieLegend.css"],"names":[],"mappings":"AAAA,oBAAoB,YAAY","sourcesContent":[".mun-squareselector{outline:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
